import React, { useContext, useState } from "react";
import { VerticalLayout, GridLayout, HorizontalLayout } from "../components/layout";
import { StandardComp } from "../atoms/standardComp";
import { CourseComp } from "../components/courseComp";
import { IconButton } from "../atoms/buttons";
import { IconText } from "../components/courseComp";
import { TextAtom } from "../atoms/TextAtom";
import { PageContext } from "../App";
import { TitleDescriptionText } from "../atoms/titleDescription";

import { TitleAction } from "../molecule/TitleAction";
import { CampagneSocials } from "./campagneSocials";
import { StepTableComp } from "./campagneTableComp";
import { NavItem } from "../atoms/navItem";


export const HeaderCampagne = ({selectedProjectDetail, setSelectedProjectDetail, LoadCampagnes, setActiveModal, setFaseModal, setActiveTitle, setShowCreateModal, projectName, handleEdit, handleTitleUpdate}) => {

  return(
          <TitleAction
            goBack={selectedProjectDetail ? () => { LoadCampagnes(); setSelectedProjectDetail(null); } : undefined}
            onClick={selectedProjectDetail
                    ? () => {
                        setActiveModal("delete");
                        setFaseModal(true);
                        setActiveTitle(`Campagne verwijderen`);
                      }
                    : () => {
                        setShowCreateModal(true);
                        setActiveTitle(`Stel je campagne samen`);
                      }}
            title={projectName}
            buttonTitle={selectedProjectDetail ? `Campagne verwijderen` : `Campagne samenstellen`}
            editable={ selectedProjectDetail && (() => handleEdit)}
            onRename={handleTitleUpdate}
          />
  )
}


export const Campaign = ({
  selectedCampagneDetail,
  setActiveModal,
  setFaseModal,
  pageType,
  removeCourse,
  formatDisplayDate,
  setstepId,
  setdates,
  isPublic,
  setActiveTitle,
}) => {
  const navigationContext = useContext(PageContext);
  const steps = selectedCampagneDetail?.steps || selectedCampagneDetail || [];
  const [ activityComp, setActivityComp] = useState(false)
  const [isSwitchActive, setSwitchActive] = useState(true);
  console.log("??///???",isSwitchActive)



  const handleDateUpdate = (step) => {
    setActiveTitle("Selecteer datum");
    setActiveModal("dateRange");
    setFaseModal(true);
    setdates({ start: step.start_date, end: step.end_date });
    setstepId(step.id_step);
  };

  const handleAddButton = (step) => {
    setstepId(step.id_step);
    setActiveModal("courses");
    setFaseModal(true);
    setActiveTitle("Selecteer een of meerdere cursussen");
  };


  return (
    <>
      {steps.some((step) => step.courses?.length > 0) &&
        steps.map((step) => (
          <StandardComp
            key={step.id_step}
            style={{
              minHeight: "40rem",
              maxHeight: "40rem",
              position: "relative",
              width: "auto",
              margin: "0 1.5rem",
              boxSizing: "border-box",
              padding: "1.5rem 0 1.5rem 1.5rem",
              marginBottom: "1.5rem",
            }}
            editClass="standard-shadow horizontal standard-margin"
            content={
              <>
                <VerticalLayout className="campaign-content" style={{ width: "100%", paddingRight: "0.5rem" }}>
                  <StepHeader
                    setActiveModal={setActiveModal}
                    setFaseModal={setFaseModal}
                    formatDisplayDate={formatDisplayDate}
                    step={step}
                    setStepId={setstepId}
                    isPublic={isPublic}
                    handleDateUpdate={handleDateUpdate}
                    setActivityComp={setActivityComp}
                    activityComp= {activityComp}
                  />
                  {/* {activityComp ? <StepTableComp headers= {["Step", "Lengte", "Aantal lessen", "Status"]}/> : */}
                  {activityComp ? <StepActivity/> :
                  isSwitchActive &&
                  <CampagneCards
                    step={step}
                    onRemoveCourse={removeCourse}
                    navigationContext={navigationContext}
                    handleAddButton={() => handleAddButton(step)}
                    pageType={pageType}
                  />}
                </VerticalLayout>
                <CampagneSocials  data={step.id_campagne} step={step.id_step} onSwitchChange={(value) => setSwitchActive(value)}  />              
              </>
            }
          />
        ))}
      {selectedCampagneDetail && (<AddStepButton onClick={() => { setActiveModal("addStep"); setFaseModal(true); }} title="Een nieuwe campagne stap aanmaken" />)}
    </>
  );
};

const courseContext = (navigationContext, course) => {
  navigationContext.handleNavigation({
    courseID: course.id_course,
    navigation: 7,
    enrollment: 0,
  });
};

const CampagneCards = ({ onRemoveCourse, step, pageType, navigationContext, handleAddButton }) => {
  const canScroll = step.courses?.length > 7;
  const isActive = step.courses >= null ;

  return (
    <GridLayout
      className={`campagne-cards ${canScroll ? "scroll" : ""}small-standard-padding no-padding-top`}
      gap="0.75rem"
      style={{ maxHeight: "calc(8 * 4rem)", overflowY: "auto" }}
    >
      {!isActive &&
        step.courses.map((course) => (
          <CourseComp
            key={course.id_course}
            pageType={pageType}
            removeCourseId={course.id_course}
            onRemoveCourse={onRemoveCourse}
            stepId={step.id_step}
            title={course.title || "Untitled Course"}
            duration={course.duration || "0m"}
            lessons={course.lessonCount || 0}
            image={course.image_url || ""}
            AI={course.ai_mode === 1}
            error={course.ai_mode === 4}
            costumColumnsTemplate="0.2fr 1fr auto auto"
            onClick={() => courseContext(navigationContext, course)}
          />
        ))}
      <AddButton onClick={handleAddButton} />
    </GridLayout>
  );
};

const AddButton = ({ onClick }) => (
  <div className="workflow-add-btn" onClick={onClick}>
    <IconButton
      style={{ color: "var(--primary-500)", backgroundColor: "transparent" }}
      color="icon-spin"
      icon2="plus"
      size={50}
    />
  </div>
);

const AddStepButton = ({ onClick, title }) => (
  <HorizontalLayout
    onClick={onClick}
    className="workflow-add-btn"
    style={{
      margin: "1.5rem",
      minHeight: "2.5rem",
      width: "auto",
      gap: "0.50rem",
      color: "var(--primary-500)",
    }}
  >
    <IconButton color="icon-spin" icon2="plus" size={30} style={{ color: "var(--primary-500)" }} />
    <TextAtom title={title} />
  </HorizontalLayout>
);

const StepHeader = ({ setActiveModal, setFaseModal, formatDisplayDate, step, today, setStepId, handleDateUpdate, isPublic, setActivityComp, activityComp }) => (
  <HorizontalLayout className="space-between">
      { !activityComp ? (<ActivityButton visibility={"visible"} onClick={() => setActivityComp(true)}/>) : (<CourseButton onClick={() => setActivityComp(false)}/>) }
      <TitleDescriptionText
      className="space-between horizontal"
      style={{ width: " auto",marginTop: "0", marginBottom: "0", paddingTop: "0", paddingLeft: "0.5rem" }}
      title={`${formatDisplayDate(step.start_date ?? today)} ${!isPublic ? `→ ${formatDisplayDate(step.end_date ?? today)}` : ""}`}
      description={!isPublic ? `${step.courses?.filter((c) => c)?.length || 0} cursussen` : undefined}
      editable={true}
      onClick={() => handleDateUpdate(step)}
    />
      <DeleteButton onClick={() => { setStepId(step.id_step); setActiveModal("deleteStep"); setFaseModal(true); }} />
  </HorizontalLayout>
);

const DeleteButton = ({ onClick }) => (
  <div onClick={onClick}>
    <IconText
      backgroundColor="var(--error-100)"
      iconColor="var(--error-600)"
      tooltipBackground="var(--error-600)"
      tooltip="Verwijderen"
      icon2="trash"
      size={50}
      color="icon-spin"
      tooltipLocation="center"
      marginBottom="0.7rem"
    />
  </div>
);

export const ActivityButton = ({ onClick, size, backgroundColor, textColor, tooltipBackground, iconColor, visibility }) => (
  <div onClick={onClick} className={"activity-button"} style={{ visibility: visibility || "hidden" }}>
    <IconText
      backgroundColor={backgroundColor || "var(--primary-200)"}
      textColor={textColor}
      iconColor={iconColor || "var(--primary-500)"}
      tooltipBackground={tooltipBackground || "var(--primary-500)"}
      tooltip="Activiteit"
      icon2="activity"
      size={size || 25}
      tooltipLocation="center"
      marginBottom="0.7rem"
    />
  </div>
);

export const TaskModalButton = ({ onClick, size, backgroundColor, textColor, tooltipBackground, iconColor, visibility }) => (
  <div onClick={onClick} className={"activity-button"} style={{ visibility: visibility || "hidden" }}>
    <IconText
      backgroundColor={backgroundColor || "var(--primary-200)"}
      textColor={textColor}
      iconColor={iconColor || "var(--primary-500)"}
      tooltipBackground={tooltipBackground || "var(--primary-500)"}
      tooltip="Activiteit"
      icon2="trash"
      size={size || 25}
      tooltipLocation="center"
      marginBottom="0.7rem"
    />
  </div>
);

const CourseButton = ({ onClick }) => (
  <div onClick={onClick}className={"activity-button active"} >
    <IconText
      backgroundColor="var(--primary-200)"
      iconColor="var(--primary-500)"
      tooltipBackground="var(--primary-500)"
      tooltip="Activiteit"
      icon2="arrow-left"
      size={20}
      tooltipLocation="center"
      marginBottom="0.7rem"
    />
  </div>
);

const StepActivity = () => {
     
}